import { CurrencyModel } from 'src/app/shared/models/CurrencyModel';

export class LpHoldingPositionRes {
  public investingEntityId: number;
  public principalBalance: number;
  public returnToDate: number;
  public totalInvested: number;
  public totalCommited: number;
  public ownershipPercentage: number;
  public irrPercentage: number;
  public adjustedIrrPercentage: number;
  public cashOnCashRatePercentage: number;
  public contributionsCurrency: CurrencyModel;
  public distributionsCurrency: CurrencyModel;
  public totalDistributed: number;
  public netAssetValue: number;
  public totalShares: number;
  public equityMultiple: number;
  public equityMultipleIncludingUnrealizedNav: number;
  public irrPercentageIncludingUnrealizedNav: number;

  static aggregate(positions: LpHoldingPositionRes[]): LpHoldingPositionRes | null {
    if (!positions?.length) return null;
    if (positions.length === 1) return positions[0];

    const totalInvested = positions.reduce((sum, p) => sum + (p.totalInvested || 0), 0);

    const weighted = (field: keyof LpHoldingPositionRes) =>
      totalInvested
        ? positions.reduce((sum, p) => sum + ((p[field] as number || 0) * (p.totalInvested || 0)), 0) / totalInvested
        : 0;
  
    // Returns null if all values are null or undefined, otherwise returns the sum
    const sum = (field: keyof LpHoldingPositionRes) => {
      const values = positions.map(p => p[field]).filter(v => v !== null && v !== undefined) as number[];
      if (values.length === 0) return null;
      return values.reduce((sum, v) => sum + (v as number), 0);
    };

    return {
      investingEntityId: null, // Not meaningful when aggregating
      principalBalance: sum('principalBalance'),
      returnToDate: sum('returnToDate'),
      totalInvested,
      totalCommited: sum('totalCommited'),
      ownershipPercentage: sum('ownershipPercentage'),
      // IRR fields: cannot aggregate, set to null
      irrPercentage: null,
      adjustedIrrPercentage: null,
      irrPercentageIncludingUnrealizedNav: null,
      // Weighted average for ratios/percentages where appropriate
      cashOnCashRatePercentage: Number(weighted('cashOnCashRatePercentage').toFixed(2)),
      contributionsCurrency: positions[0]?.contributionsCurrency ?? null,
      distributionsCurrency: positions[0]?.distributionsCurrency ?? null,
      totalDistributed: sum('totalDistributed'),
      netAssetValue: sum('netAssetValue'),
      totalShares: sum('totalShares'),
      equityMultiple: weighted('equityMultiple'),
      equityMultipleIncludingUnrealizedNav: weighted('equityMultipleIncludingUnrealizedNav'),
    };
  }
}
